import OrcaLogo from '../OrcaLogo';
import ThemeToggle from '../ThemeToggle';
import { BRAND, NAV } from './marketingCopy';

export default function MarketingLayout({ children, navigate, path, signedIn, onSignIn, onOpenApp }) {
  return (
    <div className="min-h-screen bg-orca-base text-slate-200">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-cyan-700 focus:px-3 focus:py-2 focus:text-white"
      >
        Skip to content
      </a>
      <header className="sticky top-0 z-40 border-b border-orca bg-orca-panel/95 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-3">
          <button type="button" onClick={() => navigate('/')} className="flex items-center gap-2">
            <OrcaLogo className="h-8 w-8" />
            <span className="text-left">
              <span className="block text-sm font-semibold text-orca-strong">{BRAND.name}</span>
              <span className="hidden text-[11px] text-orca-muted sm:block">{BRAND.short}</span>
            </span>
          </button>
          <nav className="ml-auto hidden items-center gap-1 md:flex" aria-label="Product">
            {NAV.map((item) => (
              <NavBtn key={item.href} item={item} path={path} navigate={navigate} />
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-2 md:ml-2">
            <ThemeToggle collapsed compact />
            {signedIn ? (
              <button
                type="button"
                onClick={onOpenApp}
                className="rounded-lg bg-cyan-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-cyan-500"
              >
                Open app
              </button>
            ) : (
              <button
                type="button"
                onClick={onSignIn}
                className="rounded-lg border border-orca bg-orca-raised px-3 py-1.5 text-xs font-medium text-orca-strong hover:brightness-110"
              >
                Sign in
              </button>
            )}
          </div>
        </div>
        <nav className="flex gap-1 overflow-x-auto border-t border-orca px-3 py-2 md:hidden" aria-label="Product mobile">
          {NAV.map((item) => (
            <NavBtn key={item.href} item={item} path={path} navigate={navigate} compact />
          ))}
        </nav>
      </header>

      <main id="main" className="mx-auto max-w-6xl px-4 py-10">
        {children}
      </main>

      <footer className="border-t border-orca bg-orca-panel">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-4">
          <p className="text-[11px] text-slate-500">
            © {new Date().getFullYear()} {BRAND.company}
          </p>
          <nav className="flex items-center gap-4" aria-label="Legal">
            <button
              type="button"
              onClick={() => navigate('/privacy')}
              className="text-sm text-slate-300 hover:text-white"
            >
              Privacy
            </button>
            <button
              type="button"
              onClick={() => navigate('/terms')}
              className="text-sm text-slate-300 hover:text-white"
            >
              Terms
            </button>
          </nav>
        </div>
      </footer>
    </div>
  );
}

function NavBtn({ item, path, navigate, compact }) {
  const active = item.href === '/' ? path === '/' : path === item.href || path.startsWith(`${item.href}/`);
  return (
    <button
      type="button"
      onClick={() => navigate(item.href)}
      className={`whitespace-nowrap rounded-lg px-2.5 py-1.5 text-xs font-medium ${
        active ? 'bg-cyan-600 text-white' : 'text-slate-300 hover:bg-orca-raised hover:text-white'
      } ${compact ? 'text-[11px]' : ''}`}
    >
      {item.label}
    </button>
  );
}
